/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Invite_Auth_NoteInputs */

const en_community_invite_auth_note = /** @type {(inputs: Community_Invite_Auth_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You will be asked to log in or create a secure account.`)
};

const id_community_invite_auth_note = /** @type {(inputs: Community_Invite_Auth_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda akan diminta untuk masuk atau membuat akun yang aman.`)
};

/** @type {(inputs: Community_Invite_Auth_NoteInputs) => LocalizedString} */
const es_community_invite_auth_note = en_community_invite_auth_note;

/** @type {(inputs: Community_Invite_Auth_NoteInputs) => LocalizedString} */
const fr_community_invite_auth_note = en_community_invite_auth_note;

/** @type {(inputs: Community_Invite_Auth_NoteInputs) => LocalizedString} */
const de_community_invite_auth_note = en_community_invite_auth_note;

/** @type {(inputs: Community_Invite_Auth_NoteInputs) => LocalizedString} */
const ja_community_invite_auth_note = en_community_invite_auth_note;

/** @type {(inputs: Community_Invite_Auth_NoteInputs) => LocalizedString} */
const zh_community_invite_auth_note = en_community_invite_auth_note;

/** @type {(inputs: Community_Invite_Auth_NoteInputs) => LocalizedString} */
const ar_community_invite_auth_note = en_community_invite_auth_note;

/** @type {(inputs: Community_Invite_Auth_NoteInputs) => LocalizedString} */
const it_community_invite_auth_note = en_community_invite_auth_note;

/** @type {(inputs: Community_Invite_Auth_NoteInputs) => LocalizedString} */
const ru_community_invite_auth_note = en_community_invite_auth_note;

/** @type {(inputs: Community_Invite_Auth_NoteInputs) => LocalizedString} */
const pt_community_invite_auth_note = en_community_invite_auth_note;

/** @type {(inputs: Community_Invite_Auth_NoteInputs) => LocalizedString} */
const ko_community_invite_auth_note = en_community_invite_auth_note;

/**
* | output |
* | --- |
* | "You will be asked to log in or create a secure account." |
*
* @param {Community_Invite_Auth_NoteInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const community_invite_auth_note = /** @type {((inputs?: Community_Invite_Auth_NoteInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Invite_Auth_NoteInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_community_invite_auth_note(inputs)
	if (locale === "es") return es_community_invite_auth_note(inputs)
	if (locale === "fr") return fr_community_invite_auth_note(inputs)
	if (locale === "de") return de_community_invite_auth_note(inputs)
	if (locale === "ja") return ja_community_invite_auth_note(inputs)
	if (locale === "zh") return zh_community_invite_auth_note(inputs)
	if (locale === "ar") return ar_community_invite_auth_note(inputs)
	if (locale === "id") return id_community_invite_auth_note(inputs)
	if (locale === "it") return it_community_invite_auth_note(inputs)
	if (locale === "ru") return ru_community_invite_auth_note(inputs)
	if (locale === "pt") return pt_community_invite_auth_note(inputs)
	return ko_community_invite_auth_note(inputs)
});